<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content mt-5 pt-5">
                <div class="row">
                  <div class="col-lg-6">
                    <h1 class="my-border-bottom" data-testing="item-name">
                      {{ currentVariation | itemName }}
                    </h1>
                    <div class="text-muted text-small mt-3">
                      {{ $translate("Ceres::Template.basketItemId") }} {{ currentVariation.item.id }}
                    </div>
                    <div v-html="currentVariation.texts.shortDescription" class="mt-3">
                    </div>
                  </div>
                  <div class="col-lg-6" v-if="extendedItemData.garantie.length > 0">
                    <div class="power-warranty d-none d-lg-block">
                      <img :src="icon" class="img-fluid mr-2" v-for="icon in extendedItemData.garantie">
                    </div>
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-6 order-2 order-lg-1">
                    <div class="d-none d-lg-block" v-html="currentVariation.texts.description"></div>
                    <template v-if="cross.length > 0">
                      <h2 class="my-border-bottom mb-4 mt-5">
                        {{ $translate("BeckerTech::Template.singleCross") }}
                      </h2>
                      <div class="row">
                        <div v-for="items in cross" class="col-3 text-center">
                          <a :href="'/'+items.data.texts.urlPath+'_'+items.data.item.id+'_'+items.data.variation.id">
                            <img :src="getImage(items.data.images)" class="img-fluid">
                            {{ items.data.texts.name2 }}
                          </a>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="col-lg-6 order-1 order-lg-2">
                    <slot name="image-carousel"></slot>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <h2 class="my-border-bottom mb-4 mt-5">
                      {{ $translate("BeckerTech::Template.singleCertificats") }}
                    </h2>

                      <div class="d-flex flex-wrap flex-lg-nowrap align-items-end">
                        <template v-if="extendedItemData.zertifikate.length > 0">
                          <div class="certificates ml-lg-5 order-sm-2">
                            <ul class="list-inline list-unstyled">
                              <li class="list-inline-item" v-for="zert in extendedItemData.zertifikate">
                                <img :src="zert" class="img-fluid">
                              </li>
                            </ul>
                          </div>
                        </template>
                        <div class="order-sm-1">
                          <div v-html="currentVariation.texts.technicalData"></div>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <h2 class="my-border-bottom mb-4 mt-5">
                      {{ $translate("Ceres::Template.singleItemTechnicalData") }}
                    </h2>
                    <div class="row">
                      <div class="col-12 col-lg-7 order-2 order-lg-1" v-if="extendedItemData.merkmale.length > 0">
                        <h3>
                          {{ $translate("BeckerTech::Template.singleMerkmale") }}
                        </h3>
                        <div class="row">
                          <div class="col-6 col-lg-4 text-center" v-for="merkmal in extendedItemData.merkmale">
                          <img :src="merkmal.image" class="img-fluid">
                          <div class="text-small">
                            {{ merkmal.desc }}
                          </div>
                        </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-5 order-1 order-lg-2" v-if="extendedItemData.performance.length > 0">
                        <h3>
                          {{ $translate("BeckerTech::Template.singlePerformance") }}
                        </h3>
                        <img :src="'https://cdn02.plentymarkets.com/iccu94qfd9gw/propertyItems/'+extendedItemData.performance[0]" class="img-fluid">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="extendedItemData.dataSheet!==''">
                  <div class="col-12">
                    <h2 class="my-border-bottom mb-4 mt-5">
                      {{ $translate("BeckerTech::Template.singleData") }}
                    </h2>
                    <div v-html="extendedItemData.dataSheet">
                    </div>
                  </div>
                </div>
                <div class="row" v-if="extendedItemData.downloads.length > 0">
                  <div class="col-12">
                    <h2 class="my-border-bottom mb-4 mt-5">
                      {{ $translate("BeckerTech::Template.singleData") }}
                    </h2>
                    <div>
                      <ul class="list-unstyled list-inline downloads">
                        <li class="list-inline-item mr-4 text-center" v-for="download in extendedItemData.downloads" v-html="download">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="bg-green px-5 py-3 mb-3">
                  <div class="widget widget-code widget-none mb-0">
                    <div class="widget-inner bg-appearance">
                      <div class="container-max py-5">
                        <div class="d-flex align-items-center flex-wrap">
                          <div class="claim text-white col-12 col-lg-7 text-center text-lg-left">
                            {{ $translate("BeckerTech::Template.singlehead") }}
                          </div>
                          <div class="col-12 col-lg-5 text-center mt-5 mt-lg-0">
                            <a :href="$translate('BeckerTech::Template.singleoffersPage')" class="btn btn-outline-white">
                              {{ $translate("BeckerTech::Template.singleaction") }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "../helper/get";
import { isNullOrUndefined } from "../helper/utils";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        cross:{
          type:Array,
          default:[]
        },
        afterKey: Object
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    computed:
    {
        getLang()
        {
          return App.language;
        },
        extendedItemData()
        {
          let current = this.currentVariation;
          let returnVal =
          {
            "performance" : [],
            "merkmale"    : [],
            "downloads"   : [],
            "zertifikate" : [],
            "garantie"    : [],
            "dataSheet"   : ""
          };
          if(current.hasOwnProperty('variationProperties'))
          {
            for(let i = 0; i < current.variationProperties.length; i++)
            {
              // performance && downloads
              if(current.variationProperties[i].id === 6)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  // performance
                  if(current.variationProperties[i].properties[i2].id === 12)
                  {
                    returnVal.performance.push(current.variationProperties[i].properties[i2].values.value)
                  }
                  // downloads
                  if(current.variationProperties[i].properties[i2].cast === "html")
                  {
                    returnVal.downloads.push(current.variationProperties[i].properties[i2].values.value)
                  }
                }
              }
              // merkmale
              if(current.variationProperties[i].id === 10)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 11)
                  {
                    for( let i3 = 0; i3 < current.variationProperties[i].properties[i2].values.length; i3++)
                    {
                      returnVal.merkmale.push(
                          {
                            "image" : 'https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Single/'+current.variationProperties[i].properties[i2].values[i3].value+'.png',
                            "desc"  : current.variationProperties[i].properties[i2].values[i3].description
                          })
                    }
                  }
                }
              }
              // zertifikate
              if(current.variationProperties[i].id === 9)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 10)
                  {
                    for( let i3 = 0; i3 < current.variationProperties[i].properties[i2].values.length; i3++)
                    {
                      returnVal.zertifikate.push('https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Single/'+current.variationProperties[i].properties[i2].values[i3].value+'.png');
                    }
                  }
                }
              }
              // dataSheet
              if(current.variationProperties[i].id === 7)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 8)
                  {
                    returnVal.dataSheet = current.variationProperties[i].properties[i2].values.value;
                  }
                }
              }
              // Garantie
              if(current.variationProperties[i].id === 11)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 15)
                  {
                    for( let i3 = 0; i3 < current.variationProperties[i].properties[i2].values.length; i3++)
                    {
                      returnVal.garantie.push('https://cdn02.plentymarkets.com/iccu94qfd9gw/frontend/shop/icons/Single/'+current.variationProperties[i].properties[i2].values[i3].value+'.png');
                    }
                  }
                }
              }
            }
          }
          return returnVal;
        },
        itemConfig()
        {
            return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });

            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);   
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
        getImage(images)
        {
          if(images.variation.length > 0)
          {
            return images.variation[0].urlPreview;
          }
          return images.all[0].urlPreview;
        },
        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
